import * as _ from 'lodash';

/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { ConfigService } from './../../../../core/services/config.service';
import { StationDetail } from '../../../shared/model/station-detail.model';
import { YardLocalDetail } from './../../../shared/model/yard-local-detail.model';
import { StaticDataStoreService } from '../../../../core/services/static-datastore.service';
/**
 * @export
 * @class YardLocalContainerHeaderComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-yard-local-container-header',
  templateUrl: './yard-local-container-header.component.html',
  styleUrls: ['./yard-local-container-header.component.scss']
})

export class YardLocalContainerHeaderComponent implements OnInit, OnChanges {

  @Input() yardLocalDetail: YardLocalDetail;
  @Input() stationDetailArr: Array<StationDetail>;
  @Output() filterDataEvent = new EventEmitter();
  origStationDetailArr: Array<StationDetail> = [];
  configData: any;
  tabLevel: number;
  showHeader: boolean;

  private ALPHABETIC_BY_DIVISION = 'alphabeticByDivision';
  private NET_ALLOCATION = 'netAllocation';
  private EXTRA_POWER = 'extraPower';
  selectedSortBy = this.ALPHABETIC_BY_DIVISION;
  selectedAlphaSortType = 'asc';
  selectedNetAllocSortType = 'asc';
  selectedExtraPowerSortType = 'desc';

  /**
   * Creates an instance of YardLocalContainerHeaderComponent.
   * @memberof YardLocalContainerHeaderComponent
   */
  constructor(private configService: ConfigService,  private staticDataStoreService: StaticDataStoreService) {
    this.configData = configService.getConfigData();
    this.tabLevel = this.configData.tabIndex.detailPage;
    if(staticDataStoreService.getValue('SHOW_HEADER') == false)
      this.showHeader = false;
    else
      this.showHeader = true;
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberof YardLocalContainerHeaderComponent
   */
  ngOnInit() {
    this.origStationDetailArr = JSON.parse(JSON.stringify(this.stationDetailArr));
  }

  /**
   * Changes in state of lifecycle hook.
   * @memberof YardLocalContainerHeaderComponent
   */
  ngOnChanges() {
    if (this.yardLocalDetail) {
      this.selectedSortBy = this.yardLocalDetail.selectedSortBy;
      this.selectedAlphaSortType = this.yardLocalDetail.selectedAlphaSortType;
      this.selectedNetAllocSortType = this.yardLocalDetail.selectedNetAllocSortType;
      this.selectedExtraPowerSortType = this.yardLocalDetail.selectedExtraPowerSortType;
    }
    this.origStationDetailArr = JSON.parse(JSON.stringify(this.stationDetailArr));
  }

  /**
   * @param {string} value
   *
   * @memberof YardLocalContainerHeaderComponent
   */
  sortByData(value: string) {
    if (value) {
      const newAllStationDetailArr: Array<StationDetail> = [];
      const newStationArr: Array<StationDetail> = [];
      for (let i = 0; i < this.stationDetailArr.length; i++) {
        if (this.stationDetailArr[i] && this.stationDetailArr[i].stationRowNum === 1) {
          newStationArr.push(this.stationDetailArr[i]);
        }
      }
      if (value === this.ALPHABETIC_BY_DIVISION) {
        if (this.selectedSortBy !== value || this.selectedAlphaSortType === 'desc') {
          newStationArr.sort(this.alphabeticByDivisionAscCompare);
          this.selectedAlphaSortType = 'asc';
        } else {
          newStationArr.sort(this.alphabeticByDivisionDescCompare);
          this.selectedAlphaSortType = 'desc';
        }
        this.selectedNetAllocSortType = 'asc';
        this.selectedExtraPowerSortType = 'desc';

      } else if (value === this.NET_ALLOCATION) {
        if (this.selectedSortBy !== value || this.selectedNetAllocSortType === 'desc') {
          newStationArr.sort(this.netAllocAscCompare);
          this.selectedNetAllocSortType = 'asc';
        } else {
          newStationArr.sort(this.netAllocDescCompare);
          this.selectedNetAllocSortType = 'desc';
        }
        this.selectedAlphaSortType = 'asc';
        this.selectedExtraPowerSortType = 'desc';

      } else if (value === this.EXTRA_POWER) {
        if (this.selectedSortBy !== value || this.selectedExtraPowerSortType === 'asc') {
          newStationArr.sort(this.extraPowerDescCompare);
          this.selectedExtraPowerSortType = 'desc';
        } else {
          newStationArr.sort(this.extraPowerAscCompare);
          this.selectedExtraPowerSortType = 'asc';
        }
        this.selectedAlphaSortType = 'asc';
        this.selectedNetAllocSortType = 'asc';
      }
      this.selectedSortBy = value;
      let otherMOWStation: StationDetail;
      for (let i = 0; i < newStationArr.length; i++) {
        for (let j = 0; j < this.origStationDetailArr.length; j++) {
          if (this.origStationDetailArr[j].allocStation === newStationArr[i].allocStation) {
            newAllStationDetailArr.push(this.origStationDetailArr[j]);
          }
          if (this.origStationDetailArr[j].allocStation === 'OTHMOW') {
            otherMOWStation = this.origStationDetailArr[j];
          }
        }
      }
      if (otherMOWStation) {
        newAllStationDetailArr.push(otherMOWStation);
      }
      this.filterDataEvent.emit(newAllStationDetailArr);
      this.yardLocalDetail.selectedSortBy = this.selectedSortBy;
      this.yardLocalDetail.selectedAlphaSortType = this.selectedAlphaSortType;
      this.yardLocalDetail.selectedNetAllocSortType = this.selectedNetAllocSortType;
      this.yardLocalDetail.selectedExtraPowerSortType = this.selectedExtraPowerSortType;
    }
  }

  /**
   * Comparator method for alphabetic by division ascending order sorting.
   *
   * @param {StationDetail} stationDetailA
   * @param {StationDetail} stationDetailB
   * @returns
   *
   * @memberof YardLocalContainerHeaderComponent
   */
  alphabeticByDivisionAscCompare(stationDetailA: StationDetail, stationDetailB: StationDetail) {
    if (stationDetailA.allocStation < stationDetailB.allocStation) {
      return -1;
    }
    if (stationDetailA.allocStation > stationDetailB.allocStation) {
      return 1;
    }
    return 0;
  }

  /**
   * Comparator method for alphabetic by division decending order sorting.
   *
   * @param {StationDetail} stationDetailA
   * @param {StationDetail} stationDetailB
   * @returns
   *
   * @memberof YardLocalContainerHeaderComponent
   */
  alphabeticByDivisionDescCompare(stationDetailA: StationDetail, stationDetailB: StationDetail) {
    if (stationDetailA.allocStation > stationDetailB.allocStation) {
      return -1;
    }
    if (stationDetailA.allocStation < stationDetailB.allocStation) {
      return 1;
    }
    return 0;
  }

  /**
   * Comparator method for net allocation ascending order sorting.
   *
   * @param {StationDetail} stationDetailA
   * @param {StationDetail} stationDetailB
   * @returns
   *
   * @memberof YardLocalContainerHeaderComponent
   */
  netAllocAscCompare(stationDetailA: StationDetail, stationDetailB: StationDetail) {
    let stationANetAlloc: number;
    let stationBNetAlloc: number;

    if (stationDetailA.netAllocPercentA) {
      stationANetAlloc = parseInt(stationDetailA.netAllocPercentA, 10);
    }
    if (stationDetailB.netAllocPercentA) {
      stationBNetAlloc = parseInt(stationDetailB.netAllocPercentA, 10);
    }
    return stationANetAlloc - stationBNetAlloc;
  }

  /**
   * Comparator method for net allocation decending order sorting.
   *
   * @param {StationDetail} stationDetailA
   * @param {StationDetail} stationDetailB
   * @returns
   *
   * @memberof YardLocalContainerHeaderComponent
   */
  netAllocDescCompare(stationDetailA: StationDetail, stationDetailB: StationDetail) {
    let stationANetAlloc: number;
    let stationBNetAlloc: number;

    if (stationDetailA.netAllocPercentA) {
      stationANetAlloc = parseInt(stationDetailA.netAllocPercentA, 10);
    }
    if (stationDetailB.netAllocPercentA) {
      stationBNetAlloc = parseInt(stationDetailB.netAllocPercentA, 10);
    }
    return stationBNetAlloc - stationANetAlloc;
  }

  /**
   * Comparator method for extra power decending order sorting.
   *
   * @param {StationDetail} stationDetailA
   * @param {StationDetail} stationDetailB
   * @returns
   *
   * @memberof YardLocalContainerHeaderComponent
   */
  extraPowerDescCompare(stationDetailA: StationDetail, stationDetailB: StationDetail) {
    let stationAExtraPower: number;
    let stationBExtraPower: number;

    if (stationDetailA.extraPowerA) {
      stationAExtraPower = parseInt(stationDetailA.extraPowerA, 10);
    }
    if (stationDetailB.extraPowerA) {
      stationBExtraPower = parseInt(stationDetailB.extraPowerA, 10);
    }
    return stationBExtraPower - stationAExtraPower;
  }

  /**
   * Comparator method for extra power ascending order sorting.
   *
   * @param {StationDetail} stationDetailA
   * @param {StationDetail} stationDetailB
   * @returns
   * @memberof YardLocalContainerHeaderComponent
   */
  extraPowerAscCompare(stationDetailA: StationDetail, stationDetailB: StationDetail) {
    let stationAExtraPower: number;
    let stationBExtraPower: number;

    if (stationDetailA.extraPowerA) {
      stationAExtraPower = parseInt(stationDetailA.extraPowerA, 10);
    }
    if (stationDetailB.extraPowerA) {
      stationBExtraPower = parseInt(stationDetailB.extraPowerA, 10);
    }
    return stationAExtraPower - stationBExtraPower;
  }
}
